import { mapArticleToDisplay } from '@/condor/application/Finsight/CreditFlowResearch/Articles/ArticlesList/helpers';
import { useArticlesThemesContext } from '@/finsight/application/CreditFlowResearch/ArticlesMarketThemesContext';
import SectorIndustryLabel from 'src/finsight/ui/common/components/CreditFlowResearch/SectorIndustryLabel';
import { usePageFiltersContext } from '@/finsight/application/PageFilters/PageFiltersContext';
import { useDictionariesContext } from '@/finsight/application/Dictionaries/DictionariesContext';

import spacesStyles from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';

const SectorIndustryCell = ({ row }) => {
  const { themes, isInitialized: isThemesInitialized } = useArticlesThemesContext();
  const { sectorsListAll: sectors, industriesListAll: industries } = useDictionariesContext();
  const { pageFilters: { productIds }, productFilters, regionFilters } = usePageFiltersContext();
  const product = productIds.length > 1 ? 'all' : productFilters.find(({ id }) => id === productIds[0])?.abbreviation;

  if (!isThemesInitialized) {
    return null;
  }

  const {
    sectorOrIndustry, subsectorOrSubindustry,
  } = mapArticleToDisplay(row, themes, productFilters, regionFilters, sectors, industries, product);

  return (
    <SectorIndustryLabel
      sectorOrIndustry={ sectorOrIndustry }
      subsectorOrSubindustry={ subsectorOrSubindustry }
      className={ spacesStyles.mrn }
    />
  );
};

export default SectorIndustryCell;
